<div id="crop-health-map-message-overlay">
  @switch (message) {
    @case (mapMessageTypeEnum.loading) {
      <div class="image-preparing">
        <div class="spinner-container"><div class="spinner"></div></div>
        <p class="title">{{ 'doktar_app.common.loading' | translate }}...</p>
        <p>{{ 'doktar_app.services.crop_monitoring.loading-message' | translate }}...</p>
      </div>
    }
    @case (mapMessageTypeEnum.imagePreparing) {
      <div class="image-preparing">
        <div class="spinner-container"><div class="spinner"></div></div>
        <p class="title">{{ 'doktar_app.common.preparing' | translate }}...</p>
        <p>{{ 'doktar_app.services.crop_monitoring.preparing_description' | translate }}</p>
      </div>
    }
    @case (mapMessageTypeEnum.cloudyWeather) {
      <div class="cloudy-weather">
        <div class="title">
          <span>☁️ {{ 'doktar_app.services.crop_monitoring.cloudy_weather' | translate }}!</span>
        </div>
        <div>{{ 'doktar_app.services.crop_monitoring.cloudy_weather_description' | translate }}</div>
      </div>
    }
    @case (mapMessageTypeEnum.problematicSpot) {
      <div class="problem-spots">
        <div class="d-flex justify-content-between">
          <div>
            <span class="spot"></span>
            <span class="title">{{ 'doktar_app.services.crop_monitoring.problem_spot' | translate }}!</span>
          </div>
          <div class="close-btn" (click)="closeOverlay()">
            <i class="ph ph-x"></i>
          </div>
        </div>
        <div>{{ 'doktar_app.services.crop_monitoring.problem_spot_description' | translate }}</div>
        <div class="d-flex justify-content-end mt-2">
          <p-button
            [label]="'doktar_app.services.crop_monitoring.see' | translate"
            severity="secondary"
            (onClick)="seeProblameticSpot.emit()" />
        </div>
      </div>
    }
    @case (mapMessageTypeEnum.noProblem) {
      <div class="no-problem">
        <div class="d-flex justify-content-between">
          <div>
            <span class="title">✅ {{ 'doktar_app.common.no_problem' | translate }}!</span>
          </div>
          <div class="close-btn" (click)="closeOverlay()">
            <i class="ph ph-x"></i>
          </div>
        </div>
        <div>{{ 'doktar_app.services.crop_monitoring.no_problematic_areas_detected_message' | translate }}</div>
      </div>
    }
    @case (mapMessageTypeEnum.outsidePlantationArea) {
      <div class="outside-plantation-area">
        <div class="d-flex justify-content-between">
          <div>
            <span class="title"> <i class="ph-fill ph-info"></i> {{ 'doktar_app.services.crop_monitoring.outside_plantation_error_title' | translate }}!</span>
          </div>
        </div>
        <div>{{ 'doktar_app.services.crop_monitoring.outside_plantation_error_description' | translate }}</div>
      </div>
    }
    @case (mapMessageTypeEnum.permiumRequired) {
      <div class="premium-required">
        <div class="d-flex justify-content-between align-items-end">
          <div>
            <p class="title">{{ 'doktar_app.services.crop_monitoring.psd_premium_title' | translate }}</p>
            <div>{{ 'doktar_app.services.crop_monitoring.psd_premium_description' | translate }}</div>
          </div>
          <dk-button [label]="'doktar_app.services.crop_monitoring.psd_premium_button' | translate" (onClick)="goToPremium()" />
        </div>
      </div>
    }
  }
</div>
